import { render, staticRenderFns } from "./FixedAssetsSettings.vue?vue&type=template&id=089d8ab8&"
import script from "./FixedAssetsSettings.vue?vue&type=script&lang=js&"
export * from "./FixedAssetsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports